var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKontrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222.36 222.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M97.19.63c123.91-11.92,172.45,149.58,68.43,207.49C78.15,256.83-23.54,174.65,4.85,78.69,16.64,38.86,55.33,4.65,97.19.63ZM115.02,212.85c80.48-2.94,126.32-94.55,79.14-160.92-18.41-25.9-47.41-40.89-79.14-42.78v203.7ZM43.04,111c-3.76,3.3-2.85,7.48,2.17,8.6,3.82.85,36.21.77,39.5-.23,1.01-.31,2.96-1.58,3.4-2.49,1.6-1.54-.75-5.88-1.98-5.88h-43.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.02,212.85V9.15c31.73,1.89,60.73,16.88,79.14,42.78,47.18,66.37,1.34,157.98-79.14,160.92ZM133.14,117.86c5.39,1.14,14.25-.84,20.08,0,1.54,0-4.95,31.75,8.81,22.03v-22.03h21.06c1.08,0,4.31-2.85,4.46-4.45.79-8.47-20.27-4.44-25.52-5.34-.79-4.69,1.49-21.3-.95-24.01-2.73-3.04-7.16-.57-7.83,2.97-.63,3.33.72,20.29-.02,21.04-5.05.83-25.32-3.02-24.54,5.34.16,1.69,3.04,4.15,4.46,4.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.04,111h43.09c1.24,0,3.58,4.34,1.98,5.88-.45.91-2.4,2.19-3.4,2.49-3.29,1.01-35.69,1.08-39.5.23-5.01-1.12-5.93-5.3-2.17-8.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.14,117.86c-1.42-.3-4.3-2.76-4.46-4.45-.78-8.36,19.49-4.51,24.54-5.34.74-.74-.61-17.7.02-21.04.67-3.55,5.1-6.01,7.83-2.97,2.44,2.71.16,19.32.95,24.01,5.25.89,26.31-3.13,25.52,5.34-.15,1.61-3.38,4.45-4.46,4.45h-21.06v22.03c-13.76,9.71-7.27-22.03-8.81-22.03-5.83-.84-14.69,1.14-20.08,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKontrast);
export default __webpack_public_path__ + "static/media/Kontrast.ec88b56d249f3833f954f89d31a74036.svg";
export { ForwardRef as ReactComponent };